import { FC, ComponentType } from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'

type InjectedProps = {
  mdmClientNumber: number
  lysHomepageEnabled: boolean
}

export type PrivateRouteProps = {
  component: ComponentType<InjectedProps>
  mdmClientNumber: number
  lysHomepageEnabled: boolean
}

const PrivateRoute: FC<PrivateRouteProps> = ({
  component: Component,
  mdmClientNumber,
  lysHomepageEnabled,
  ...rest
}) => {
  const loyaltyToken = localStorage.getItem('@loyalty:token')

  return (
    <Route
      {...rest}
      render={props =>
        !loyaltyToken ? (
          <Redirect to="/faca-parte" />
        ) : (
          <Component
            {...props}
            mdmClientNumber={mdmClientNumber}
            lysHomepageEnabled={lysHomepageEnabled}
          />
        )
      }
    />
  )
}

export default withRouter(PrivateRoute)
